import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from "react-router-dom";
import Modal from 'react-bootstrap/Modal';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import * as model from '../../models/InterviewsModel';
import { apiError } from '../../helpers/ErrorHelper';
import { useAuth } from '../../context/AuthContext';
//import { useNotificationCount } from '../../../context/NotificationCountContext';
import { DatePicker, MyReactSelect, MySelect, MyTimePicker, Text, TextArea, HiddenInput } from '../inputs/inputs';
import { formatDataBeforeDisplay, formatDataBeforeSend, quickAddClient } from '../../helpers/GeneralHelper';
import { getData as getClients } from '../../models/ClientsModel';
import { getData as getRequirements } from '../../models/RequirementsModel';
//import { getData as getCandidates } from '../../models/CandidatesModel';
import * as interviewStatusModel from '../../models/InterviewStatusModel';
import * as interviewRoundsModel from '../../models/InterviewRoundsModel';
// import { QuickAdd } from '../../modals/QuickAdd';
// import AdminLayout from '../../layout/AdminLayout';
// import { Helmet } from 'react-helmet';
// import PageHeader from '../../common/PageHeader';
// import { checkPermission } from "../../../helpers/GeneralHelper";

export const InterviewAddFromCandidate = ({ showModal, setShowModal, candidateData, statusId, onSuccess, onDismiss}) => {
    const inputFields = {
        interview_client_id: '',
        interview_requirement_id: '',
        interview_candidate_id: '',
        candidate_status_id: statusId,
        interview_round_id: '',
        interview_date: '',
        interview_time: '',
        interview_mode: '',
        interview_status_id: '',
        interview_remarks: '',
    }
    const formatOptions = [
        {
          type: 'react-select',
          column: 'interview_client_id',
          labelColumn: 'client_name'
        },
        {
          type: 'react-select',
          column: 'interview_requirement_id',
          labelColumn: 'requirement_name'
        },
        {
          type: 'react-datepicker',
          column: 'interview_date',
        },
        {
          type: 'react-timepicker',
          column: 'interview_time',
        },
        {
            type: 'hidden',
            column: 'interview_candidate_id' //,
            // labelColumn: '_candidate_id'
        },
        {
            type: 'hidden',
            column: 'candidate_status_id',
            //labelColumn: 'candidate_status_id'
        },
    ];
    const location = useLocation();
    const module = location.state?.module;
    const { state } = useAuth();
    let user_data = state.user_data;
    const navigate = useNavigate(); 

    const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  
  //const [id, setId] = useState('');
  const [fields, setFields] = useState(inputFields);

  const [quickModals, setQuickModals] = useState({ clients: false });

  const resetModal = () => {
    setFields(inputFields);
    setErrors({});
    setShowModal(false);
  };

  const closeModal = () => {
    resetModal();
    onDismiss?.();
  }

  const optionsModeOfInterviews = [
    {value: 'F2F', label: 'F2F' },
    {value: 'Virtual', label: 'Virtual' },
  ];

  const [clients, setClients] = useState([]);
  const [requirements, setRequirements] = useState([]);
  const [allRequirements, setAllRequirements] = useState([]);
  const [candidates, setCandidates] = useState([]);
  const [rounds, setRounds] = useState([]);
  const [interviewStatus, setInterviewStatus] = useState([]);
  const [staId , setStatusId] = useState(statusId);
  const fetchClients = async (candidate_id = '') => {
    try {
      const result = await getClients({user_token: user_data.user_token, page: 1, limit: -1, candidate_id:candidate_id});
      if (! result) return;

      const clientOptions = result.clients.map(client => ({
        value: client._client_id,
        label: client.client_name
      }));

      setClients(clientOptions);
    } catch (error) {
      console.error(error);
    }
  };

  const fetchStatus = async() => {
    try {
      let apiParam = {user_token: user_data.user_token, page: 1, limit: -1};
      const response = await interviewStatusModel.getData(apiParam);

      if (typeof response != typeof undefined) {
        const options = response.interview_status.map(ele => ({
          value: ele._status_id,
          label: ele.status_name
        }));

        setInterviewStatus(options);
      }
    } catch (error) {
      console.error(error);
    }
  }

  const fetchRounds = async() => {
    try {
      let apiParam = {user_token: user_data.user_token, page: 1, limit: -1};
      const response = await interviewRoundsModel.getData(apiParam);

      if (typeof response != typeof undefined) {
        const options = response.interview_rounds.map(ele => ({
          value: ele._interview_round_id,
          label: ele.interview_round_name
        }));

        setRounds(options);
      }
    } catch (error) {
      console.error(error);
    }
  }
  useEffect(() => {
    if (candidateData) {
      //console.log(candidateData);
      // setFields({candidate_status_id: statusId});
      // //console.log('statusId => ', statusId);
      // setFields({interview_candidate_id : candidateData._candidate_id});
      // Merge fields properly
      setFields(prev => ({
        ...prev,
        candidate_status_id: statusId,
        interview_candidate_id: candidateData._candidate_id,
        // prefill client and requirement IDs
        interview_client_id: candidateData.candidate_client_id 
          ? { value: candidateData.candidate_client_id, label: candidateData.client_name }
          : '',
        interview_requirement_id: candidateData.candidate_requirement_id
          ? { value: candidateData.candidate_requirement_id, label: candidateData.requirement_name }
          : '',
      }));

      // Fetch related dropdowns
      setStatusId(statusId);
      setErrors({});
      fetchClients(candidateData._candidate_id);
      fetchRequirements(candidateData._candidate_id);
    }
    fetchStatus();
    fetchRounds();
    
}, [candidateData]);

  const [loadingRequirements, setLoadingRequirements] = useState(false);
  //useEffect(() => {
    const fetchRequirements = async(candidate_id = '') => {
      var interview_client_id = '';
      if (fields.interview_client_id) {
        interview_client_id = fields.interview_client_id.value;
        // fields.interview_requirement_id = '';
        // setRequirements([]);
        // return;
      }
      if(candidate_id=='' && fields.interview_candidate_id){
        candidate_id = fields.interview_candidate_id.value;
      }

      setLoadingRequirements(true);

      try {
        let apiParam = {user_token: user_data.user_token,  page: 1, limit: -1};
        //, 'requirement_client_id': interview_client_id,candidate_id:candidate_id 
        const response = await getRequirements(apiParam);

        if (typeof response != typeof undefined) {
          let options = [];
          let flag = false;
          response.requirements.forEach(function(item) {
            if (fields.interview_requirement_id == item._requirement_id || fields.interview_requirement_id?.value == item._requirement_id) {
              flag = true;
            }
            options.push({
              value: item._requirement_id,
              label: item.requirement_name,
              client_id: item.requirement_client_id, // needed for local filter
            });
          });

          if (! flag) {
            fields.interview_requirement_id = '';
          }

          setRequirements(options);
          setAllRequirements(options);
        }
      } catch (error) {
        console.error(error);
      }

      setLoadingRequirements(false);
    }
    const clientChange = async(cli_obj) => {
      if (cli_obj.value) {
        const filtered = allRequirements.filter(req => req.client_id == cli_obj.value);
        setRequirements(filtered);

        // Clear selected requirement if not found in filtered list
        if (
          fields.interview_requirement_id &&
          !filtered.some(req => req.value === fields.interview_requirement_id.value)
        ) {
          setFields(prev => ({ ...prev, interview_requirement_id: '' }));
        }
      } else {
        setRequirements([]); // or set to allRequirements if no client selected
      }
    };
    const submit = async(e) => {
        e.preventDefault();
        
        // Start the loading state
        setLoading(true);
    
        try {
          // Clear previous errors
            setErrors({});
            //console.log('fields => ',fields);//return false;
            const formData = formatDataBeforeSend(fields, inputFields, formatOptions);

            let response;
            //console.log(formData);
          
            response = await model.create(user_data.user_token, formData);
    
            if (response.status) {
                toast.success(response.message);
                if (onSuccess) {
                  resetModal();
                  onSuccess(response);
                } else {
                  navigate('/interviews');
                }
            
            } else {
                setErrors(response.error);
                toast.error(response.message);
            }
        } catch (error) {
          apiError(error);
    
          if (error.response?.data.invalid_token == 1) {
            navigate('/re-login');
          }
        }
    
        // Stop the loading state
        setLoading(false);
      }
    //fetchRequirements();
  //}, [fields.interview_client_id]);

    return (
        <>
        <Modal show={showModal} onHide={closeModal} size='xl' backdrop="static">
            <Modal.Header closeButton>
                <Modal.Title>Schedule Interview For {candidateData.candidate_firstname+' '+candidateData.candidate_lastname}</Modal.Title>
            </Modal.Header>

            <form onSubmit={submit}>
                <Modal.Body>
                    <div className="row gy-2">
                        <div className="col-sm-4 mt-3">
                            <HiddenInput column="interview_candidate_id" fields={fields} setFields={setFields} errors={errors} value={candidateData._candidate_id} />
                            <HiddenInput column="candidate_status_id" fields={fields} setFields={setFields} errors={errors} value={statusId} />
                            <label className="form-label">Candidate <span className="text-danger">*</span></label>
                            <input type="text" className="form-control" placeholder="Candidate" readonly="true" value={candidateData.candidate_firstname+' '+candidateData.candidate_lastname} />
                            {/* <MyReactSelect options={candidates} column="interview_candidate_id" label="Candidate" required={true} fields={fields} setFields={setFields} errors={errors} disabled={loadingCandidates} /> */}
                        </div>
                        <div className="col-sm-4 mt-3">
                            <MyReactSelect options={clients} column="interview_client_id" label="Client" required={true} fields={fields} setFields={setFields} errors={errors} quickAddKey="clients" quickAddSet={setQuickModals} onChange={clientChange} />
                        </div>

                        <div className="col-sm-4 mt-3">
                            <MyReactSelect options={requirements} column="interview_requirement_id" label="Requirement" required={true} fields={fields} setFields={setFields} errors={errors} disabled={loadingRequirements} />
                        </div>
                        
                        <div className="col-sm-4 mt-3">
                            <MySelect options={rounds} column="interview_round_id" label="Round" required={true} fields={fields} setFields={setFields} errors={errors} />
                        </div>
                        
                        <div className="col-sm-4 mt-3">
                            <DatePicker column="interview_date" label="Date" required={true} fields={fields} setFields={setFields} errors={errors} />
                        </div>
                        
                        <div className="col-sm-4 mt-3">
                            <MyTimePicker column="interview_time" label="Time" required={true} fields={fields} setFields={setFields} errors={errors} />
                        </div>
                        
                        <div className="col-sm-4 mt-3">
                            <MySelect options={optionsModeOfInterviews} column="interview_mode" label="Mode" required={true} fields={fields} setFields={setFields} errors={errors} />
                        </div>
                        
                        <div className="col-sm-4 mt-3">
                            <MySelect options={interviewStatus} column="interview_status_id" label="Status" required={true} fields={fields} setFields={setFields} errors={errors} />
                        </div>
                        
                        <div className="col-sm-4 mt-3">
                            <TextArea column="interview_remarks" label="Remarks" fields={fields} setFields={setFields} errors={errors} />
                        </div>
                    </div>
                </Modal.Body>

                <Modal.Footer>
                    <button type="button" className="btn btn-light" onClick={closeModal}>Cancel</button>
                    <button className="btn btn-primary" disabled={loading}>
                        {loading ? <span><span className="spinner-border spinner-border-sm align-middle"></span> Loading...</span> : 'Submit'}
                    </button>
                </Modal.Footer>
            </form>
        </Modal>

        </>
    );
};